import React from 'react'
import IconBase from './IconBase'

const Alert = props => (
  <IconBase viewBox="0 0 17.7 17.7" {...props}>
    <g transform="translate(549.86 308.86) rotate(180)">
      <path d="m547.3 293.7c-3.5-3.5-9.1-3.5-12.5 0-3.5 3.5-3.5 9.1 0 12.5 3.5 3.5 9.1 3.5 12.5 0 3.4-3.4 3.4-9 0-12.5zm-5.1 10.1c0 0.6-0.5 1.2-1.2 1.2s-1.2-0.5-1.2-1.2v-4.6c0-0.6 0.5-1.2 1.2-1.2s1.2 0.5 1.2 1.2v4.6zm-1.2-6.6c-0.6 0-1.1-0.4-1.1-1v-0.1c0-0.6 0.4-1 1-1.1h0.1c0.6 0 1.1 0.4 1.1 1s-0.4 1.1-1 1.1c0 0.2-0.1 0.2-0.1 0.1z" />
    </g>
  </IconBase>
)

export default Alert
